import { render, staticRenderFns } from "./StockUpList.vue?vue&type=template&id=b28c4672&scoped=true&"
import script from "./StockUpList.vue?vue&type=script&lang=js&"
export * from "./StockUpList.vue?vue&type=script&lang=js&"
import style0 from "./StockUpList.vue?vue&type=style&index=0&id=b28c4672&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28c4672",
  null
  
)

export default component.exports